import { useGetTranslations } from '@/composables/useGetTranslations';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
import { useUser } from '~/composables/_next/useUser';
export default {
  name: 'EmptyCart',
  components: {
    AzButton: AzButton,
    AzIcon: AzIcon,
    NuxtLinkCustom: NuxtLinkCustom
  },
  setup: function setup() {
    var route = useRoute();
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var _useUser = useUser(),
      isAuthenticated = _useUser.isAuthenticated;
    var _useUiState = useUiState(),
      toggleCartSidebar = _useUiState.toggleCartSidebar,
      handleLoginNavigation = _useUiState.handleLoginNavigation;
    var isLogin = computed(function () {
      return isAuthenticated.value;
    });
    return {
      route: route,
      translate: translate,
      isLogin: isLogin,
      toggleCartSidebar: toggleCartSidebar,
      handleLoginNavigation: handleLoginNavigation
    };
  }
};